export const INS_ACT_Checkbox_Types = [
  { key: "komPom", label: "KOM / PIM" },
  { key: "materialInspection", label: "Material Inspection" },
  { key: "inProcessInspection", label: "In-process Inspection" },
  { key: "finalInspection", label: "Final Inspection" },
  { key: "documentReview", label: "Document Review" },
  { key: "fatSat", label: "FAT / SAT" },
  { key: "wpsPqrWpq", label: "WPS / PQR / WPQ" },
  { key: "preDispatchInspection", label: "Pre-dispatch Inspection" },
  { key: "laboratoryTesting", label: "Laboratory Testing" },
  { key: "coatingInspection", label: "Coating Inspection" },
  { key: "calibration", label: "Calibration" },
  { key: "reInspection", label: "Re-inspection" },
];

export const GEN_TextField_Types = [
  { label: "DYC Global Control ID No.", subLabel: "", key: "controlId" },
  { label: "RFI Details:", subLabel: "", key: "rfiDetails" },
  { label: "Inspection Date(s):", subLabel: "", key: "inspectionDates", isDate: true },
  { label: "Location of Inspection:", subLabel: "", key: "locationOfInspection", multiline: true },
  { label: "DYC Client:", subLabel: "", key: "clientName" },
  { label: "End User:", subLabel: "", key: "endUser" },
  { label: "Project:", subLabel: "(Name, Number & Location)", key: "project", multiline: true },
  { label: "Contractor Name & Number:", subLabel: "(PMC/EPC, if applicable)", key: "contractorNameNumber" },
  { label: "Vendor:", subLabel: "(Name & Location)", key: "vendor", multiline: true },
  { label: "P.O. Number:", subLabel: "(Client PO on Vendor)", key: "poNumberClient" },
  { label: "Sub - Vendor:", subLabel: "(Name & Location, if applicable)", key: "subVendor" },
  { label: "P.O. Number", subLabel: "(Vendor PO on sub-Vendor)", key: "poNumberVendor" },
];

export const detailsItemHeaders = [
  { label: "PO Item No", field: "poItemNo" },
  { label: "Item Code", field: "itemCode" },
  { label: "Item Description / Identification Number / MTC Number / Manufacturer", field: "itemDescription" },
  { label: "P.O. Quantity with UOM", field: "poQuantityWithUom" },
  { label: "Offered Quantity with UOM", field: "offeredQuantityWithUom" },
  { label: "Acceptable Quantity with UOM", field: "acceptableQuantityWithUom" },
];


export const applicableDocumentsHeaders = [
  { label: "Document Name", field: "documentName" },
  { label: "Client Document Number", field: "clientDocumentNumber" },
  { label: "Vendor Document Numbe", field: "vendorDocumentNumber" },
  { label: "Approval Status", field: "approvalStatus" },
];

export const OPEN_CLOSE_OPTIONS = [
  { label: "Select", value: 0 },
  { label: "NA", value: 1 },
  { label: "Open", value: 2 },
  { label: "Close", value: 3 },
];

export const areaofConcernHeaders = [
  { label: "Area of Concern / Observations / Non - Conformities", field: "areaOfConcern" },
  { label: "Date Initiated", field: "dateInitiated", type: "date" },
  { label: "Open / Close", field: "openClose", type: "select", options: OPEN_CLOSE_OPTIONS },
  { label: "Action By", field: "actionBy" },
];

export const detailsWitnessHeaders = [
  { label: "QAP Stage", field: "qapStage" },
  { label: "Activities description as Per QAP", field: "activitiesDescription" },
];

export const detailsReviewedHeaders = [
  { label: "QAP Stage", field: "qapStage" },
  { label: "Activities description as Per QAP", field: "reviewedactivitiesDescription" },
];

export const detailsEquipmentInspectionHeaders = [
  { label: "Name of Equipment", field: "nameOfEquipment" },
  { label: "Range", field: "ranges" },
  { label: "ID No", field: "idNo" },
  { label: "Calibration Due Date", field: "calibrationDueDate", type: "date" },
  { label: "Calibration Certificate Number.", field: "calibrationCertificateNumber" },
  { label: "Traceability to NABL / ISO 17025 accredited lab (Yes/No)", field: "traceability" },
];


export const HSE_CHECK_POINTS = [
  { key: "c1", label: "Is the equipment/energy properly isolated?" },
  { key: "c2", label: "If someone works above me, am I protected from falling objects?" },
  { key: "c3", label: "If a permit is required (e.g., confined space entry), do I possess it?" },
  { key: "c4", label: "Have I communicated with other groups about their activities?" },
  { key: "c5", label: "Are tools and equipment in good condition and appropriately tagged?" },
  { key: "c6", label: "Am I fit for this task?" },
  { key: "c7", label: "In my work environment, is all necessary equipment (vehicles, conveyors, etc.) isolated?" },
  { key: "c8", label: "If the task involves heavy lifting, am I equipped to manage this factor?" },
  { key: "c9", label: "Is the walking surface free of slip, trip, and fall hazards?" },
  { key: "c10", label: "If extreme weather conditions are a factor in this job, are there measures in place to manage it?" },
  { key: "c11", label: "Is the appropriate barricading in place for the task?" },
  { key: "c12", label: "Am I familiar with the equipment I inspect?" },
];


// deafult data for creation 
export const defaultApplicableDocuments = [
  { documentName: "PR/MR/ARM/TDC", isNew: true },
  { documentName: "QAP/ITP/MQP", isNew: true },
  { documentName: "Drawing(s)", isNew: true },
  { documentName: "Datasheet(s)", isNew: true },
  { documentName: "Procedure(s)", isNew: true },
  { documentName: "Others (Specify)", isNew: true },
];